import * as React from 'react';
import { ComplexValue } from '../types';
import { MdHome } from 'react-icons/md';
import { insertOptionalWordbreaks } from 'app/infrastructure/platform';
import styles from './breadcrumb-item.scss';

export type BreadcrumbValue = ComplexValue<number>;

export interface BreadcrumbItemProps {
  item: BreadcrumbValue;
  onClickItem: (item: BreadcrumbValue) => void;
  last: boolean;
  home?: boolean;
  homeLabel?: string;
  onClickBreadcrumbHome?: () => void;
}

export const BreadcrumbItem = (props: BreadcrumbItemProps) => {
  const onItemClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    props.onClickItem(props.item);
  };

  if (props.home || props.item.description === '') {
    const homeLabel = props.homeLabel && insertOptionalWordbreaks(props.homeLabel);

    return <li className="breadcrumb-item breadcrumb-home">
      {<a href="#" onClick={onItemClick} className="standalone-link"><MdHome />
        {homeLabel ? <span className={styles.homeLabel}>{homeLabel}</span> : null}</a>}
    </li>;
  }

  return <li className="breadcrumb-item">
    {
      props.last
        ? insertOptionalWordbreaks(props.item.description)
        : <a href="#" className="standalone-link" onClick={onItemClick}>{insertOptionalWordbreaks(props.item.description)}</a>
    }
  </li>;
};
